import { useTranslation } from 'react-i18next';

import {
    Button,
    Heading1,
    Stack,
    Subtitle1,
} from '@myphx-engineering/phx-design-system';
import { IllustrationCard, LillyFamilyIllustration } from '@phx/myphx-lib';

export const SupportPage = () => {
    const { t } = useTranslation();

    const handleClick = () => {
        location.href = `tel:+18445593471`;
    };

    return (
        <Stack gap="xl" flex="1" justify="space-between">
            <IllustrationCard
                variant="bare"
                withShadow={false}
                illustrationPosition="top"
                Illustration={LillyFamilyIllustration}
            >
                <Stack align="center" gap="sm">
                    <Heading1>{t('supportPage.heading')}</Heading1>

                    <Stack gap="md" align="center">
                        <Stack gap="0" align="center">
                            <Subtitle1>
                                {t('supportPage.callUs.subtitle')}
                            </Subtitle1>
                            <Subtitle1>
                                {t('supportPage.callUs.phoneNumber')}
                            </Subtitle1>
                        </Stack>

                        <Stack gap="0" align="center">
                            <Subtitle1>
                                {t('supportPage.hours.subtitle')}
                            </Subtitle1>
                            <Subtitle1>
                                {t('supportPage.hours.hoursOfOperation')}
                            </Subtitle1>
                        </Stack>
                    </Stack>

                    <Subtitle1>{t('supportPage.subtitle')}</Subtitle1>
                </Stack>
            </IllustrationCard>

            <Button fullWidth onClick={handleClick}>
                {t('supportPage.button')}
            </Button>
        </Stack>
    );
};
